import { Grid, Typography, Link, Box, Button } from '@mui/material';
import { Event } from '@mui/icons-material';
import mdiLightEmail from '../../images/mdi-light_email.png';
import phMsTeams from '../../images/ph_microsoft-teams-logo-light.png';
import timeIcon from '../../images/time.png';
import eventCalendarIcon from '../../images/eventCalendar.svg';
import { useStyles } from './style';

export const NeedHelp = () => {
  const classes = useStyles();

  return (
    <Box style={{ marginTop: '80px' }}>
      <p className={classes.needHelpTitle}>Still need help?</p>
      <Grid container spacing={2} sx={{ mt: 1, gridAutoFlow: 'row', marginBottom: '40px' }}>
        <Grid item sm={12} md={4}>
          <Box className={classes.needHelpContainer}>
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
              <img src={timeIcon} className={classes.needHelpButtonIcon} alt="time icon" />
              Office Hours
            </Typography>
            <Typography variant="body2">
              Held Tuesdays and Thursdays from 11:00 AM - 12:00 PM ET
            </Typography>
            <Typography variant="body2">
              No sign up needed, just drop in with questions. First come, first served.
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              href="https://help.workforcegps.org/resources/2022/11/02/13/59/WorkforceGPS-Help-Desk-and-Office-Hours#office-hours"
              className={classes.needHelpButton}
            >
              <img src={phMsTeams} className={classes.needHelpButtonIcon} alt="MS Teams icon" />
              <Typography variant="body2">View Office Hours on TA Help</Typography>
            </Button>
          </Box>
        </Grid>
        <Grid item sm={12} md={4}>
          <Box className={classes.needHelpContainer}>
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
              <img src={eventCalendarIcon} className={classes.needHelpButtonIcon} alt="calendar icon" />
              Schedule a Meeting
            </Typography>
            <Typography variant="body2">
              If you can&apos;t join during our dedicated Office Hours, you can schedule a meeting at a time that works for you. No need to email, follow the prompts and choose from available options. You&apos;ll receive a meeting invite automatically.
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              href="https://help.workforcegps.org/resources/2022/11/02/13/59/WorkforceGPS-Help-Desk-and-Office-Hours#schedule-a-meeting"
              className={classes.needHelpButton}
            >
              <Event sx={{ fontSize: 18, mr: 1, color: '#6264A7' }} />
              <Typography variant="body2">Schedule a Meeting on TA Help</Typography>
            </Button>
          </Box>
        </Grid>
        <Grid item sm={12} md={4}>
          <Box className={classes.needHelpContainer}>
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
              <img src={mdiLightEmail} className={classes.needHelpButtonIcon} alt="email icon" />
              Help Desk
            </Typography>
            <Typography variant="body2">
              Email the Events Support team anytime: <Link href="mailto:events@workforcegps.org">events@workforcegps.org</Link>
            </Typography>
            <Typography variant="body2">
              This email ensures multiple <strong>Events Support</strong> team members can review and respond, so no requests get missed. An events team member will respond during business hours (9-5 ET) after reviewing your request.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NeedHelp; 